import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
///import { spinner, spinnerClose } from '../helpers/spinners';
import { startSpinner,finishSpinner } from "./ui/spinner";

export const candidatosBajaTraerStart = () => ({ type: types.candidatosBajaTraerStart });
export const candidatosBajaLimpiar = () => ({ type: types.candidatosBajaLimpiar });
export const candidatosBajaTraerError = (error) => ({ type: types.candidatosBajaTraerError,payload: error});
export const candidatosBajaTraerSuccess = (payload) => {
    return {
      type: types.candidatosBajaTraerSuccess,
      payload: payload
    }
  }
  
export const fetchCandidatosBaja = (idSituacionRevista, periodo) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        dispatch(candidatosBajaTraerStart());
        const response = await fetchConToken(`PropuestaBaja/traerPorSitRev/${idSituacionRevista}/${periodo}`);
        if (!response.ok) {
            console.log( await response.json() );
            dispatch(candidatosBajaTraerError(response.statusText));
            // throw Error(response.statusText);
        }
        else{
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
              const lista = await response.json();
              dispatch(candidatosBajaTraerSuccess(lista));
          }
        }
        dispatch(finishSpinner());
    };
  };

  export const updateCandidatosBaja = (idSituacionRevista, periodo) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        dispatch(candidatosBajaTraerStart());
        const response = await fetchConToken(`PropuestaBaja/generar`, {idSituacionRevista, periodo} , 'POST');
        if (!response.ok) {
            console.log( await response.json() );
            dispatch(candidatosBajaTraerError(response.statusText));
            // throw Error(response.statusText);
        }
        else{
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
              const lista = await response.json();
              dispatch(candidatosBajaTraerSuccess(lista));
          }
        }
        dispatch(finishSpinner());
    };
  };

  export const generatePdf = (idTipo, periodo, filters = null) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        dispatch(candidatosBajaTraerStart());
        const uri = filters != null ? `PropuestaBaja/generatePdf/${idTipo}/${periodo}?filters=${encodeURIComponent(JSON.stringify(filters))}` : `PropuestaBaja/generatePdf/${idTipo}/${periodo}`;
        const response = await fetchConToken(uri);
        if (!response.ok) {
            console.log( await response.json() );
            dispatch(candidatosBajaTraerError(response.statusText));
            // throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/pdf") !== -1) {
            try{
              const blob = await response.blob ();
              window.open(URL.createObjectURL(blob));
            }
            catch (err)
            {
              console.log( err );
            }
        }
        dispatch(finishSpinner());
    };
  };

  export const exportExcel = (idTipo, periodo, filters = null) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        dispatch(candidatosBajaTraerStart());
        const uri = filters != null ? `PropuestaBaja/exportExcel/${idTipo}/${periodo}?filters=${encodeURIComponent(JSON.stringify(filters))}` : `PropuestaBaja/exportExcel/${idTipo}/${periodo}`;
        const response = await fetchConToken(uri);
        if (!response.ok) {
            console.log( await response.json() );
            dispatch(candidatosBajaTraerError(response.statusText));
            // throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("officedocument.spreadsheetml") !== -1) {
            try{
              const blob = await response.blob ();
              
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement('a');
              a.href = url;
              a.download = 'CandidatosABaja.xlsx';
              a.click();
            }
            catch (err)
            {
              console.log( err );
            }
        }
        dispatch(finishSpinner());
    };
  };

  export const filtrarCandidatosBaja = (idMotivo) => dispatch => {
    dispatch({
        type: types.candidatosBajaFiltrar,
        payload: idMotivo
    });
  }

  export const realizarBaja = (fechaBaja, afiliados) => {
    return async (dispatch, getState) => {
        dispatch(startSpinner());
        dispatch(candidatosBajaTraerStart());
        const response = await fetchConToken(`PropuestaBaja/realizarBaja`, {fechaBaja, afiliados} , 'PUT');
        if (!response.ok) {
            console.log( await response.json() );
            console.log( response );
            dispatch(candidatosBajaTraerError(response.statusText));
            // throw Error(response.statusText);
        }
        else {
          const state = getState();
          const { items } = state.candidatosBaja;
          const filteredList = items.filter(
            function(e) {
              return this.indexOf(e.idAfiliado) < 0;
            },
            afiliados
          );
          dispatch(candidatosBajaTraerSuccess(filteredList));
        }
        dispatch(finishSpinner());
    };
  };